import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useConfigStore } from '@/store/config-store'
import { useBuildStore } from '@/store/build-store'
import { BuilderLayout } from '@/components/layout/BuilderLayout'
import { ModelCard } from '@/components/builder/ModelCard'
import { Spinner } from '@/components/ui/Spinner'
import { Button } from '@/components/ui/Button'
import { trackStepViewed, trackModelSelected } from '@/lib/tracking'

export default function ModelSelect() {
  const navigate = useNavigate()
  const { load, loading, config } = useConfigStore()
  const { selectedModelId, selectModel, setStep } = useBuildStore()

  useEffect(() => { load() }, [load])
  useEffect(() => { trackStepViewed('model') }, [])

  const handleSelect = (id: number) => {
    selectModel(id)
    trackModelSelected(id)
  }

  const handleContinue = () => {
    if (!selectedModelId) return
    setStep('customize')
    navigate('/build/customize')
  }

  return (
    <BuilderLayout showSummary={!!selectedModelId}>
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-slate-900 mb-1">Choose Your Model</h1>
        <p className="text-slate-500">Select the base shell that fits your needs. You'll customize it next.</p>
      </div>

      {loading && (
        <div className="flex justify-center py-16">
          <Spinner size="lg" />
        </div>
      )}

      {config && (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-8">
            {config.models.map((model) => (
              <ModelCard
                key={model.id}
                model={model}
                isSelected={selectedModelId === model.id}
                onSelect={() => handleSelect(model.id)}
              />
            ))}
          </div>

          {selectedModelId && (
            <div className="sticky bottom-4 flex justify-end md:hidden">
              <Button size="lg" onClick={handleContinue}>
                Customize →
              </Button>
            </div>
          )}

          <div className="hidden md:flex justify-end">
            <Button size="lg" onClick={handleContinue} disabled={!selectedModelId}>
              Customize This Model →
            </Button>
          </div>
        </>
      )}
    </BuilderLayout>
  )
}
